/** Other relative date options can also be created here, with the same properties
 * id - Used to identify which relative date is selected
 * label - Used to display as label for the relative date
 * relativeDateType - Could be either RELATIVE_DATE_TYPE_NEXT or RELATIVE_DATE_TYPE_PAST
 * daysCount - Used to calculate start and end date based upon relativeDateType
 */

import { getSchoolYearToDateNumberOfDays } from 'components/Common/DateRangeFilter/utils';

export const RELATIVE_DATE_TYPE_NEXT = 'next';
export const RELATIVE_DATE_TYPE_PAST = 'past';

export const NEXT_7_DAYS = 'next_7';
export const NEXT_14_DAYS = 'next_14';
export const NEXT_30_DAYS = 'next_30';
export const NEXT_60_DAYS = 'next_60';
export const NEXT_90_DAYS = 'next_90';

export const PAST_90_DAYS = 'past_90';
export const PAST_60_DAYS = 'past_60';
export const PAST_30_DAYS = 'past_30';
export const PAST_14_DAYS = 'past_14';
export const PAST_7_DAYS = 'past_7';

export const SCHOOL_YEAR_TO_DATE_ID = 'school_year_to_date';
export const MONTH_TO_DATE_ID = 'month_to_date';

export const PAST_7 = {
  id: PAST_7_DAYS,
  label: 'Past 7 days',
  relativeDateType: RELATIVE_DATE_TYPE_PAST,
  daysCount: 7,
};

export const PAST_30 = {
  id: PAST_30_DAYS,
  label: 'Past 30 days',
  relativeDateType: RELATIVE_DATE_TYPE_PAST,
  daysCount: 30,
};

export const NEXT_7_TO_NEXT_90 = [
  {
    id: NEXT_7_DAYS,
    daysCount: 7,
    label: 'Next 7 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
  {
    id: NEXT_14_DAYS,
    daysCount: 14,
    label: 'Next 14 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
  {
    id: NEXT_30_DAYS,
    daysCount: 30,
    label: 'Next 30 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
  {
    id: NEXT_60_DAYS,
    daysCount: 60,
    label: 'Next 60 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
  {
    id: NEXT_90_DAYS,
    daysCount: 90,
    label: 'Next 90 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
];

export const PAST_90_TO_PAST_7 = [
  {
    id: PAST_90_DAYS,
    daysCount: 90,
    label: 'Past 90 days',
    relativeDateType: RELATIVE_DATE_TYPE_PAST,
  },
  {
    id: PAST_60_DAYS,
    daysCount: 60,
    label: 'Past 60 days',
    relativeDateType: RELATIVE_DATE_TYPE_PAST,
  },
  {
    id: PAST_30_DAYS,
    daysCount: 30,
    label: 'Past 30 days',
    relativeDateType: RELATIVE_DATE_TYPE_PAST,
  },
  {
    id: PAST_14_DAYS,
    daysCount: 14,
    label: 'Past 14 days',
    relativeDateType: RELATIVE_DATE_TYPE_PAST,
  },
  PAST_7,
];

export const PAST_90_TO_NEXT_90 = [
  {
    id: PAST_90_DAYS,
    daysCount: 90,
    label: 'Past 90 days',
    relativeDateType: RELATIVE_DATE_TYPE_PAST,
  },
  {
    id: PAST_60_DAYS,
    daysCount: 60,
    label: 'Past 60 days',
    relativeDateType: RELATIVE_DATE_TYPE_PAST,
  },
  PAST_30,
  {
    id: NEXT_30_DAYS,
    daysCount: 30,
    label: 'Next 30 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
  {
    id: NEXT_60_DAYS,
    daysCount: 60,
    label: 'Next 60 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
  {
    id: NEXT_90_DAYS,
    daysCount: 90,
    label: 'Next 90 days',
    relativeDateType: RELATIVE_DATE_TYPE_NEXT,
  },
];

export const SCHOOL_YEAR_TO_DATE = {
  id: SCHOOL_YEAR_TO_DATE_ID,
  label: 'This school year',
  relativeDateType: RELATIVE_DATE_TYPE_PAST,
  daysCount: getSchoolYearToDateNumberOfDays(),
};

export const MONTH_TO_DATE = {
  id: MONTH_TO_DATE_ID,
  label: 'This month',
  relativeDateType: RELATIVE_DATE_TYPE_PAST,
  daysCount: new Date().getDate(),
};

export const DEFAULT_RELATIVE_DATE_OPTIONS = NEXT_7_TO_NEXT_90;
export const DEFAULT_RELATIVE_PAST_DATE_OPTIONS = PAST_90_TO_PAST_7;

export const CUSTOM_RANGE = 'custom_range';
export const ALL_TIME = 'all_time';
